var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"app-logo",attrs:{"to":"/","data-node":"header-logo"}},[_c('img',{attrs:{"src":require("assets/img/logo.svg"),"alt":"HUM Nutrition - Home"}})])}
var staticRenderFns = []

export { render, staticRenderFns }